import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { Box, Typography } from '@mui/material';
import Checkmark from 'console/images/pin-dialog/checkmark.svg';
import { Circle, KeyPad, RoundButton } from 'console/app-settings/pin-dialogs/utils';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { useCallbacks } from 'shared/hooks/utils';
import { close_pin_dont_match_dialog, close_set_pin_dialog, open_pin_dont_match_dialog, set_pin, } from 'console/app-settings/redux/actions';
const min_pin_length = 3;
export function SetPinDialog() {
    const opened = useAppSelector((state) => state.app_settings.opened_set_pin_dialog);
    const closeSettingPinDialog = useAction(close_set_pin_dialog);
    const closePinsDontMatchDialog = useAction(close_pin_dont_match_dialog);
    const openPinsDontMatchDialog = useAction(open_pin_dont_match_dialog);
    const onSetPin = useAction(set_pin);
    const onSetPinFinish = useCallback((pin) => {
        closeSettingPinDialog();
        onSetPin(pin);
        closePinsDontMatchDialog();
    }, [closeSettingPinDialog, onSetPin, closePinsDontMatchDialog]);
    const onSetPinFail = useCallbacks([closeSettingPinDialog, openPinsDontMatchDialog]);
    const [stage, setStage] = useState(1);
    const [input, setInput] = useState('');
    const [pin, setPin] = useState(null);
    const [too_short, set_too_short] = useState(false);
    useEffect(() => {
        if (opened) {
            setStage(1);
            setInput('');
            set_too_short(false);
        }
    }, [opened, setStage, setInput, set_too_short]);
    const on_digit = useCallback((digit) => {
        setInput((input + digit).substr(0, 8));
        set_too_short(false);
    }, [setInput, input, set_too_short]);
    const on_release = useCallback(() => {
        if (stage === 2 && input.length === pin?.length) {
            if (input === pin) {
                onSetPinFinish(input);
            }
            else
                onSetPinFail();
        }
    }, [stage, input, pin, onSetPinFinish, onSetPinFail]);
    const on_clear = useCallback(() => setInput(''), [setInput]);
    const on_entered = useCallback(() => {
        if (input.length < min_pin_length)
            set_too_short(true);
        else {
            setStage(2);
            setInput('');
            setPin(input);
        }
    }, [input, set_too_short, setStage, setInput, setPin]);
    let title;
    let error = false;
    if (stage === 1) {
        if (too_short) {
            error = true;
            title = `Не менее ${min_pin_length} цифр`;
        }
        else
            title = 'Задайте пин-код';
    }
    else
        title = 'Повторите пин-код';
    return (_jsxs(MessageBox, { open: opened, title: title, onClose: closeSettingPinDialog, children: [error && (_jsx(Typography, { variant: "subtitle1", color: "error", children: title })), _jsx(Box, { sx: {
                    fontSize: '48px',
                    display: 'flex',
                    flexFlow: 'row nowrap',
                    justifyContent: 'center',
                    height: '62px',
                    lineHeight: 1,
                    '& > div': {
                        flexBasis: '38px',
                        flexShrink: 1,
                        textAlign: 'center',
                    },
                }, children: stage === 1
                    ? new Array(input.length)
                        .fill(0)
                        .map((_, i) => _jsx(Circle, { filled: true }, i))
                    : new Array(pin?.length ?? 0)
                        .fill(0)
                        .map((_, i) => _jsx(Circle, { filled: i < input.length }, i)) }), _jsx(KeyPad, { onDigit: on_digit, onClear: on_clear, onRelease: on_release, cornerButton: stage === 1 ? (_jsx(RoundButton, { onClick: on_entered, children: _jsx(Checkmark, {}) })) : undefined })] }));
}
